import React, { useEffect } from "react";
import { MobXProviderContext, Observer } from "mobx-react";

// Sagres Rotas React example components
import { Card, CardContent, Grid, ListItem, Typography } from "@mui/material";
import Header from "components/Header/Header";

function HistoricoView() {
  const { mapaStore } = React.useContext(MobXProviderContext);

  var height = window.innerHeight

  useEffect(() => {
    mapaStore.buscarPedidosHistorico();
  }, []);

  return (
    <div>
      <Header />

      <div style={{ position: 'relative', width: '100%', height: `${height - 130}px` }}>

        <Card style={{ height: '105%', margin: '32px', padding: 0, }}>
          <CardContent style={{ padding: 0, width: '100%', height: `${height - 130}px`}}>
            <Typography gutterBottom variant="h5" component="div" style={{ marginLeft: 5, paddingTop: 16, paddingLeft: 8 }}>
              Histórico de Pedidos
            </Typography>

            <Observer >{() =>
              <div style={{
                display: "flex",
                // flexFlow: "column wrap",
                flexFlow: "column",
                gap: "0 15px",
                height: `${height - 170}px`,
                overflow: "auto"
              }}>
                {mapaStore.pedidosHistorico.length > 0 ? mapaStore.pedidosHistorico.map((pedido) => (
                  <ListItem key={pedido.id} style={{
                    width: "auto"
                  }}>
                    <div style={{ width: '100%', paddingTop: 8, paddingBot: 8, paddingLeft: 16, paddingRight: 16 }}>

                      <Card style={{ width: '100%' }} >
                        <CardContent>
                          <Grid container >
                            <Grid item xs container direction="column" >
                              <Typography gutterBottom variant="h6" component="div">
                                {`${pedido.sequenciaPdv} - ${pedido.cliente} (${pedido.identificacao})`}
                              </Typography>
                              <Typography variant="body2" fontWeight='fontWeightMedium' gutterBottom>
                                {`${pedido.status}`}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                {`${pedido.endereco} `}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                {`${pedido.entregador.Nome !== undefined ? ' Entregador: ' + pedido.entregador.Nome : ''}`}
                              </Typography>
                            </Grid>

                          </Grid>

                        </CardContent>
                      </Card>
                    </div>
                  </ListItem>
                )) : <Typography style={{ opacity: 0.5 }} variant="h6" gutterBottom>
                  'Não há pedidos no momento.'

                </Typography>}
              </div>



            }</Observer>
          </CardContent>
        </Card>
      </div>

    </div>
  );
}

export default HistoricoView;
